var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 4.66669L9.42108 9.91244C9.15706 10.1765 9.02506 10.3085 8.87284 10.3579C8.73894 10.4014 8.59471 10.4014 8.46082 10.3579C8.3086 10.3085 8.17659 10.1765 7.91258 9.91244L6.08774 8.0876C5.82373 7.82359 5.69173 7.69158 5.53951 7.64212C5.40561 7.59862 5.26138 7.59862 5.12748 7.64212C4.97527 7.69158 4.84326 7.82359 4.57925 8.0876L1.3335 11.3334M14.6668 4.66669H10.0002M14.6668 4.66669V9.33335",
    stroke: "#12B76A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/trend-up.1feff64b1b1f501cbac0e179d8978727.svg";
export { ForwardRef as ReactComponent };